import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { showToast } from "../../redux/actions/toastActions";

const MultiChipInputv2 = ({
  setInputValue,
  setChips,
  inputValue,
  chips,
  limit,
  required,
  label,
  note,
  style,
  placeholder,
}) => {
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleInputKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim() !== "") {
      e.preventDefault();
      if (
        chips?.length > 0 &&
        chips?.includes(inputValue.trim()?.toLowerCase())
      ) {
      } else if (limit && chips.length < limit) {
        setChips([...chips, inputValue.trim()]);
      } else if (!limit) {
        setChips([...chips, inputValue.trim()]);
      } else {
        dispatch(
          showToast({
            message: `Only ${limit} can be added at max`,
            category: "danger",
          })
        );
      }
      setInputValue("");
    } else if (e.key === "Backspace" && inputValue === "" && chips.length > 0) {
      setChips(chips.slice(0, -1));
    }
  };

  const handleChipRemove = (chipIndex) => {
    const updatedChips = chips.filter((_, index) => index !== chipIndex);
    setChips(updatedChips);
  };

  const handleDivClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const handleInputBlur = () => {
    if (inputValue.trim() !== "") {
      if (
        chips?.length > 0 &&
        chips?.includes(inputValue.trim()?.toLowerCase())
      ) {
      } else if (limit && chips.length < limit) {
        setChips([...chips, inputValue.trim()]);
      } else if (!limit) {
        setChips([...chips, inputValue.trim()]);
      } else {
        dispatch(
          showToast({
            message: `Only ${limit} can be added at max`,
            category: "danger",
          })
        );
      }
      setInputValue("");
    }
  };

  const inputWidth =
    (inputValue?.length ? inputValue?.length + 2 : 3) * 10 + "px";
  return (
    <div className="mb-9 relative" style={{ ...style }}>
      <label htmlFor="chips" className="text-[14px] font-[500] pl-1">
        <>
          {required ? (
            <>
              {label}
              &nbsp;<span className="text-red-600">*</span>
            </>
          ) : (
            <>{label}</>
          )}
        </>
      </label>

      <p className="text-black text-opacity-[0.5] text-sm pt-0 mb-1 pl-1 font-medium">
        {note ? note : "Press 'Enter' key to add more"}
      </p>
      <div
        className="flex flex-wrap items-center w-full min-h-[40px] bg-[#F4F6F9] border-[1px] border-[#C5C5C7] text-gray-900 text-[12px] rounded-lg placeholder-transparent focus:ring-transparent focus:border-primary focus:border-[1px] px-2.5 py-1 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white font-medium dark:focus:ring-blue-500 dark:focus:border-blue-500"
        onClick={handleDivClick}
      >
        <div className="flex w-full flex-wrap gap-2 cursor-text">
          {chips?.map((chip, index) => {
            return (
              <div
                className="border border-gray-300 flex justify-center items-center rounded-[10px] h-[30px] py-0.5 px-1.5 bg-white font-medium"
                key={index}
              >
                {chip}
                <img
                  src="/svgs/Cross.svg"
                  alt="cross"
                  className="w-[18px] ml-2 cursor-pointer"
                  onClick={() => handleChipRemove(index)}
                />
              </div>
            );
          })}
          <input
            id="chips"
            type="text"
            value={inputValue}
            style={inputValue ? { width: inputWidth } : { width: "150px" }}
            placeholder={
              inputValue || chips?.length > 0
                ? ""
                : placeholder || "Enter Emails here"
            }
            className="appearance-none border-0 h-[30px] bg-gray-50 text-[12px] p-0 focus:border-0 focus:ring-transparent w-[100%]"
            onChange={handleInputChange}
            onKeyDown={handleInputKeyDown}
            ref={inputRef}
            onBlur={handleInputBlur}
          />
        </div>
      </div>
    </div>
  );
};

export default MultiChipInputv2;
